var _this = this;

import React, { memo } from 'react';
import { Grid } from '@material-ui/core';
import { Icon, Form } from 'ecrion-components';
var selectProps = {
  label: null,
  variant: 'filled',
  multi: false,
  menuPlacement: 'auto'
};

var FieldMappings = function FieldMappings(props) {
  var name = props.name,
      index = props.index,
      mappingOptions = props.mappingOptions,
      onRemove = props.onRemove;
  return React.createElement(Grid, {
    container: true
  }, React.createElement(Grid, {
    item: true,
    sm: 5,
    xs: 5
  }, React.createElement(Form.Fields.MultiSelect, Object.assign({
    name: name + '.Source.Name',
    id: name + '.Source.Name',
    options: mappingOptions.sources
  }, selectProps))), React.createElement(Grid, {
    item: true,
    sm: 1,
    xs: 1
  }), React.createElement(Grid, {
    item: true,
    sm: 5,
    xs: 5
  }, React.createElement(Form.Fields.MultiSelect, Object.assign({
    name: name + '.Destination.Name',
    id: name + '.Destination.Name',
    options: mappingOptions.destinations
  }, selectProps))), React.createElement(Grid, {
    item: true,
    sm: 1,
    xs: 1,
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'end'
    }
  }, React.createElement(Icon, {
    type: "remove",
    onClick: onRemove.bind(_this, index),
    style: {
      paddingLeft: '6rem'
    }
  })));
};

export default memo(FieldMappings);